import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageErrorLayout } from '../../Layout';

var PageError500 = function PageError500() {
  var _useTranslation = useTranslation(['dsPageError']),
      t = _useTranslation.t;

  var onClick = function onClick() {
    return window.location.reload();
  };

  return /*#__PURE__*/React.createElement(PageErrorLayout, {
    errorCode: 500,
    description: t('500_DESCRIPTION'),
    buttonText: t('500_BUTTON_TEXT'),
    onClick: onClick
  });
};

export default PageError500;